import { Router } from '@angular/router';
import { Component, OnInit, Input, TemplateRef } from '@angular/core';

import {SessionStorageService} from 'ngx-webstorage';
import { Adal5Service } from './services/adal/adal5.service';
import { isNumeric } from 'rxjs/util/isNumeric';

import { SecretService } from './services/secret.service';
import { DisplayStateService } from './services/DisplayStateService';
import { WebPlatformApiService } from './services/WebPlatformApiService';
import { ClientSettingsService } from './services/ClientSettingsService';
import { AppStateService } from './services/AppStateService';
import { UtilityFunctions } from './classes/UtilityFunctions';
import { Config } from './config';

@Component({
  selector: 'app-web-platform-main-component',
  template: `<div id="router-outlet" class="router-outlet">
    <router-outlet></router-outlet>
</div>`,
  styles: [``]
})
export class MainComponent implements OnInit {
  @Input() widgetContainer: TemplateRef<any>;
  private lastRouterUrl = '';

  constructor(
    private adalService: Adal5Service,
    private secretService: SecretService,
    private displayStateService: DisplayStateService,
    private sessionStorageService: SessionStorageService,
    private webPlatformApiService: WebPlatformApiService,
    private clientSettingsService: ClientSettingsService,
    private appStateService: AppStateService,
    private router: Router) {
    var _this = this;
    var adalConfig = {
      instance: this.secretService.adalConfig.instance,
      tenant: this.secretService.adalConfig.tenant,
      clientId: this.secretService.adalConfig.clientId,
      expireOffsetSeconds: 15, 
      redirectUri: this.secretService.adalConfig.redirectUri,
      postLogoutRedirectUri: window.location.origin + '/',
      popUp: true,
      cacheLocation: "localStorage",
      callback: null
    };
    adalConfig.callback = function () {
      console.log('Callback called');
      _this.adalService.refreshDataFromCache();
      if (!(adalService.userInfo && adalService.userInfo.authenticated)) {
        console.log('User not authenticated inside callback');
      }
      else {
        // _this.userInfo = _this.adalService.userInfo;
      }
    };
    this.adalService.init(this.secretService.adalConfig);

    const omelekVersion = Config.version;
    this.clientSettingsService.VersionInfo.push({ name: 'Omelek Version', value: omelekVersion });
  }

  HandleAdfs() {
    if (!this.adalService.userInfo.authenticated) {
      const qIndex = window.location.href.indexOf('?');
      if (qIndex > -1) {
        this.sessionStorageService.store('query.parameters', decodeURI(window.location.href.substr(qIndex + 1)));
      } else {
        this.sessionStorageService.clear('query.parameters');
      }
      this.adalService.login();
    } else {
      this.lastRouterUrl = <string>this.sessionStorageService.retrieve('query.parameters');
      if (this.lastRouterUrl != null && this.lastRouterUrl.length > 0) {
        this.displayStateService.RouteFromQueryParamString(this.lastRouterUrl);
        this.sessionStorageService.clear('query.parameters');
        this.lastRouterUrl = '';
      }

      this.displayStateService.appState.current.xMtAdfsOpenid = <string>this.sessionStorageService.retrieve('access_token');
      // do not clear it from sessionStorage.. this.sessionStorageService.clear('access_token');
      // it will get overwritten as needed, but we can't pull this one from the adalService cache the same way as the id_token.. 

      this.webPlatformApiService.GetIsAdmin().subscribe(x => {
        this.displayStateService.appState.current.userIsAdmin = x;
      });

      this.adalService.getUser().subscribe(x => {
        this.displayStateService.SetUser(x);
      },
        err => {
          console.log(`getUser ERROR: ${err}`);
        },

        () => {
          console.log(`getUser COMPLETED`);
        });
    }
  }

  checkApiVersion() {
    this.webPlatformApiService.GetApiVersion().subscribe(

      version => {
        this.displayStateService.appState.apiVersion = version;
        this.clientSettingsService.VersionInfo.push({name: 'Middle Layer Version', value: version});
        try {
          const results = UtilityFunctions.checkApiVersion([1, 1, 1, 0], this.displayStateService);
          if (results.pass) {
            UtilityFunctions.Log(3, results.message, this.clientSettingsService, this.appStateService);
          } else if (results.error) {
            UtilityFunctions.Log(1, results.errorMessage, this.clientSettingsService, this.appStateService);
            this.displayStateService.RaiseErrorToast('certain functionality will not be available or will cause errors');
          } else {
            UtilityFunctions.Log(1, results.message, this.clientSettingsService, this.appStateService);
            this.displayStateService.RaiseErrorToast('certain functionality will not be available or will cause errors');
          }
        } catch (ex) {
          const msg = (<Error>ex).message;
          UtilityFunctions.Log(1, msg, this.clientSettingsService, this.appStateService);
          this.displayStateService.RaiseErrorToast('certain functionality will not be available or will cause errors');
        }
      },
      error => {
        this.displayStateService.RaiseErrorToast('Unable to determine the version of the platform middle layer api: ');
        const errMsg = error.message ? error.message : error.toString();
        this.displayStateService.RaiseErrorToast(errMsg);
        UtilityFunctions.Log(1, errMsg, this.clientSettingsService, this.appStateService);
        this.displayStateService.RaiseErrorToast('certain functionality will not be available or will cause errors');
      }
    );
  }
  
  ngOnInit() {
    if (window.location.hash.indexOf('id_token') !== -1) {
      if (window.location.hash.indexOf('access_token') !== -1) {
        // save off the adfs access_token, it can be used in API STORE later. (as x-mt-adfs-openid)
        const hashParams: any = {};
        // substr(1) to remove the # character
        window.location.hash.substr(1).split('&').map(p => {
          let name = p.split('=')[0];
          let val = p.split('=')[1];
          let obj = {};
          hashParams[name] = val;
        })
        this.sessionStorageService.store('access_token', hashParams.access_token);
        this.displayStateService.appState.current.xMtAdfsOpenid = hashParams.access_token;
      }
      // callback after loading adfs.micron.com and getting a token in our url, only do this if the url hash has a id_token in it..
      this.adalService.handleWindowCallback();
    }
    this.checkApiVersion();
    if (this.clientSettingsService.SkipAuthentication) {
      this.displayStateService.appState.current.userIsAdmin = true;
      this.displayStateService.SetUser({ userName: 'LocalHost@micron.com', profile: undefined });
      console.log(`SkipAuthentication: setting user to LocalHost@micron.com and bypassing ADFS`);
      return;
    } else {
      this.HandleAdfs();
    }
    // save the widgetContainer component as an input template from the instance in a shared service for convenience
    // this is needed for aot
    this.displayStateService.widgetContainer = this.widgetContainer;
  }
}
